export {
  default,
  LocaleConsumer,
  LocaleContextProps,
  LocaleProvider,
  LocaleProviderProps,
} from "./Locale";
